<template>
  <div>
    <myheader></myheader>
    <van-image :src="require('../../assets/img/about_banner.png')"/>
    <h1 style="font-size: 1.2rem; color: #333333; font-weight: normal; text-align: center;">新闻资讯</h1>
    <hr width="10%" style="border: 1px solid #000;">
    <div class="about_content">
      <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
      >
        <template v-for="(item, index) in list">
          <van-cell :key="index" style="margin: 0 0 10px 0; padding: 0 0 10px 0;" @click="ToDetail(item)">
            <van-row :key="index">
              <van-col span="6">
                <van-image :src="item.image ? item.image.url : ''" height="3.6rem"/>
              </van-col>
              <van-col span="18" style="padding-left: 1rem;">
                <h3 class="act_list_x_t">{{ item.title }}</h3>
                <p class="act_list_x_d">{{item.description}}</p>
                <span>{{ item.created_at }}</span>
              </van-col>
            </van-row>
          </van-cell>
        </template>
      </van-list>
    </div>
    <myfooter></myfooter>
  </div>
</template>

<script>
import {Field, Button, Cell, CellGroup, Toast, Swipe, SwipeItem, Image, Row, Col, Grid, GridItem, List} from 'vant'
import { getNewsList } from '@/api'

export default {
  name: 'NewsList',
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Image.name]: Image,
    [Row.name]: Row,
    [Col.name]: Col,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [List.name]: List,
    [Button.name]: Button,
  },
  data() {
    return {
      loading: false,
      finished: false,
      list: []
    }
  },
  methods: {
    onLoad() {
      this.loading = true
      getNewsList().then(res => {
        for (let i in res.data.data){
          this.list.push(res.data.data[i])
        }
        if(res.data.current_page >= res.data.last_page) {
          this.finished = true
        }
        this.loading = false
      }).catch(err => {
        this.loading = false
        this.finished = true
      })
    },
    ToDetail(item) {
      this.$router.push({ path: '/news/' + item.id })
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
  .about_content {
    padding: 1rem 1.5rem 2.1rem;
    font-size: 0.78rem;
    font-weight: normal;
    color: #666666;
    line-height: 1.2rem;
  }
  .act_list_x_t {
    font-size: 0.84rem;
    margin: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #333333;
  }
  .act_list_x_d {
    font-size: 0.66rem;
    margin-top: 0.05rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-bottom: 0.1rem;
    color: #999999;
  }
</style>
